import { useEffect } from 'react'
import { useAppSelector } from '@/store/hooks'

const EMPTY_GRACE_MS = 400

/**
 * Панели показать нечего — выбора нет: ни экрана, ни существующего урока (выбранное
 * удалили, у курса нет уроков). Тогда сообщить владельцу, чтобы выезжающая шторка
 * телефона закрылась. Считается по ВЫБОРУ, а не по черновику: черновик пропадает и
 * на перечитывании списка экранов (возврат во вкладку, из другого приложения), и
 * шторка с открытыми настройками захлопывалась бы на ровном месте.
 */
export const useReportEmptyPanel = (lesson: unknown, onEmpty: (() => void) | undefined) => {
  const hasBlock = useAppSelector((s) => s.editor.selectedBlockId !== null)
  const isEmpty = !hasBlock && lesson === null
  useEffect(() => {
    if (!isEmpty) return
    // С выдержкой: урок на мгновение «пропадает», пока курс перечитывается.
    const t = window.setTimeout(() => onEmpty?.(), EMPTY_GRACE_MS)
    return () => window.clearTimeout(t)
  }, [isEmpty, onEmpty])
}
